import { Button } from '@/components/ui'
import {
  caseSummaryText,
  ProjectCaseFields,
  useProjectCaseForm,
} from '@/modules/projects'
import { WizardStep } from './WizardStep'

interface ProjectCaseStepProps {
  open: boolean
  onToggle: () => void
}

export const ProjectCaseStep = ({ open, onToggle }: ProjectCaseStepProps) => {
  const form = useProjectCaseForm({ saveOnChange: true })

  const summary = caseSummaryText(form)

  return (
    <WizardStep
      step={1}
      title="About the case"
      description="Tell us the kind of matter so the report is tailored to it. Everything here is optional and can be changed later."
      summary={summary}
      open={open}
      onToggle={onToggle}
      isFirst
    >
      <div className="rounded-lg border bg-white p-6">
        <ProjectCaseFields form={form} />

        {form.isLoaded && (
          <div className="mt-4 flex justify-end">
            <Button theme="outline" onClick={onToggle}>
              Done
            </Button>
          </div>
        )}
      </div>
    </WizardStep>
  )
}
